// Funciones utilitarias básicas que no dependen de bases de datos ni otros módulos complejos

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * @description Genera un ID basado en la fecha actual (AAMMDD)
 * @returns {string} Ejemplo: "250721" para 21/07/2025
 */
export const generateIdDateNow = (): string => {
    const now = new Date()
    const year = String(now.getFullYear()).slice(-2) // "25"
    const month = String(now.getMonth() + 1).padStart(2, '0') // "07"
    const day = String(now.getDate()).padStart(2, '0') // "21"
    return `${year}${month}${day}`
}

/**
 * @param {boolean} local
 * @returns hora string local (arg utc-3) o internacional utc-0
 */
export const getDateNow = (local: boolean = false): string => {
    return local ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString() : new Date().toISOString()
}

export const isLocalGeneratedId = (id: string) => {
    // Regex para UUID v4: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return uuidV4Regex.test(id)
}

/**
 * @param id cualquier valor
 * @description valida si el id es un string de 24 caracteres hexadecimales (0-9, a-f)
 * @returns {boolean}
 */
export const isValidMongoId = (id: any): boolean => {
    return typeof id === 'string' && /^[a-fA-F0-9]{24}$/.test(id)
}

export const padCodeComplete = (code: number, cantDigit: number): string => {
    return String(code).padStart(cantDigit, '0')
}